import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import axios from "axios";
import moment from "moment";
export default {
  props: {
    studentId: {
      type: [Number, String],
      required: true
    },
    institution: {
      type: String,
      required: true
    },
    username: {
      type: String,
      default: ""
    },
    schedule: {
      type: Object,
      default: null
    },
    defaultDate: {
      type: String,
      default: ""
    }
  },
  emits: ["close", "saved"],
  data() {
    const schedule = this.schedule || {};
    return {
      saving: false,
      timeRange: schedule.period ? schedule.period.split("-") : [],
      form: {
        title: schedule.title || "",
        date: schedule.date ? String(schedule.date).slice(0, 10) : this.defaultDate,
        scheduleContent: schedule.scheduleContent || "",
        remark: schedule.remark || ""
      },
      repeat: false,
      weekdays: [],
      weekdayNames: ["日", "一", "二", "三", "四", "五", "六"],
      endMode: "date",
      repeatEndDate: "",
      showConflicts: false,
      conflicts: [],
      savedWithConflicts: false
    };
  },
  methods: {
    repeatChanged() {
      if (this.repeat && !this.weekdays.length && this.form.date) this.weekdays = [moment(this.form.date).day()];
      if (this.repeat && !this.repeatEndDate && this.form.date) {
        this.repeatEndDate = moment(this.form.date).add(3, "months").format("YYYY-MM-DD");
      }
    },
    toggleWeekday(day) {
      this.weekdays = this.weekdays.includes(day) ? this.weekdays.filter(value => value !== day) : [...this.weekdays, day].sort();
    },
    disabledEndDate(date) {
      return !!this.form.date && moment(date).format("YYYY-MM-DD") < this.form.date;
    },
    conflictDateLabel(row) {
      if (!row.recurring) return row.date;
      return `${row.date} 至 ${row.endDate || "永不截止"}，每周${this.weekdayNames[row.weekday]}`;
    },
    conflictsClosed() {
      if (this.savedWithConflicts) this.$emit("saved");
    },
    async save() {
      if (!this.form.title.trim() || !this.form.date || !Array.isArray(this.timeRange) || this.timeRange.length !== 2 || !this.timeRange.every(Boolean)) return alert("请填写主题、日期和时间段");
      if (this.timeRange[0] >= this.timeRange[1]) return alert("结束时间必须晚于开始时间");
      if (this.repeat && (!this.weekdays.length || this.endMode === "date" && (!this.repeatEndDate || this.repeatEndDate < this.form.date))) return alert("请选择重复星期和有效的截止日期");
      this.saving = true;
      try {
        const response = await axios.post("https://backend.wonology.com/courseArrange/studentSchedule/save", {
          id: this.schedule && this.schedule.id,
          studentId: this.studentId,
          institution: this.institution,
          username: this.username,
          ...this.form,
          title: this.form.title.trim(),
          period: this.timeRange.join("-"),
          repeat: !this.schedule && this.repeat,
          weekdays: this.weekdays,
          repeatEndDate: this.endMode === "never" ? null : this.repeatEndDate
        });
        const result = response.data.data || {};
        if (result.conflicts && result.conflicts.length) {
          this.conflicts = result.conflicts;
          this.savedWithConflicts = result.saved === true;
          this.showConflicts = true;
          return;
        }
        if (response.data.code !== "0000") return alert(response.data.msg);
        this.$emit("saved");
      } catch (error) {
        alert("保存日程失败：" + error);
      } finally {
        this.saving = false;
      }
    },
    async remove() {
      if (!confirm(`确认删除 ${this.schedule.date} 的日程“${this.schedule.title}”吗？${this.schedule.repeatId ? "只删除当天，其他日期保留。" : ""}`)) return;
      this.saving = true;
      try {
        const response = await axios.post("https://backend.wonology.com/courseArrange/studentSchedule/delete", {
          id: this.schedule.id,
          studentId: this.studentId,
          institution: this.institution
        });
        if (response.data.code !== "0000") return alert(response.data.msg);
        this.$emit("saved");
      } catch (error) {
        alert("删除日程失败：" + error);
      } finally {
        this.saving = false;
      }
    }
  }
};